import { render, staticRenderFns } from "./FretTest.vue?vue&type=template&id=47a0a8f4"
import script from "./FretTest.vue?vue&type=script&lang=js"
export * from "./FretTest.vue?vue&type=script&lang=js"
import style0 from "./FretTest.vue?vue&type=style&index=0&id=47a0a8f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports